









































































import { Component } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import DatePicker from "@/shared/components/date-picker.vue";
import { validDate } from "@/shared/validators";
import {
  FiltrosNotificacoesApple,
  Log,
  NotificacoesAppleService,
} from "@/services/notificacoes-apple.service";
import DataTable from "@/shared/components/data-table.vue";
import { dateTime, dateTimeSecondsFormatIso } from "@/shared/filters";
import Tooltip from "@/shared/components/tooltip.vue";
import AssociarNotificacaoApple from "./modals/AssociarNotificacaoApple.vue";
import dayjs from "dayjs";
import Visualizar from "./modals/Visualizar.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";

@Component({
  components: {
    DataTable,
    DatePicker,
    Tooltip,
    AssociarNotificacaoApple,
    Visualizar,
  },
  filters: { dateTime, dateTimeSecondsFormatIso },
})
export default class NotificacoesApple extends mixins(GlobalMixin) {
  promiseNotificacoesApple: Promise<any[]> | null = null;

  dadosForm: FiltrosNotificacoesApple = {
    dataInicio: "",
    dataFinal: "",
    offset: 0,
    limit: 100,
    order: "",
  };

  rules = {
    dataInicio: [validDate()],
    dataFinal: [validDate()],
  };

  headersNotificacoesApple = [
    { value: "logNotificacaoApple.idLogNotificacaoApple", text: "Id" },
    { value: "data", text: "Data Recebimento Mensagem" },
    {
      value: "notification.unifiedReceipt.latestReceiptInfo[0].productId",
      text: "Assinatura Apple",
      sortable: false
    },
    { value: "dataTransacao", text: "Data da Transação", sortable: false },
    { value: "dataExpiracao", text: "Data da Expiração", sortable: false },
    {
      value:
        "notification.unifiedReceipt.latestReceiptInfo[0].originalTransactionId",
      text: "Código Transação Original",
      sortable: false
    },
    { value: "logNotificacaoApple.ambiente", text: "Ambiente" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.dadosForm.dataInicio = dayjs().subtract(3, "day").format("YYYY-MM-DD");
    this.dadosForm.dataFinal = dayjs().format("YYYY-MM-DD");
  }

  fetchNotificacaoApple(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.dadosForm, options);
    }
    this.promiseNotificacoesApple = NotificacoesAppleService.lista(this.dadosForm);
  }

  async associar(item: any) {
    const modal = this.$refs
      .associarNotificacaoApple as AssociarNotificacaoApple;
    await modal.associarNotificacaoApple(
      item.logNotificacaoApple.idLogNotificacaoApple
    );
  }

  visualizar(log: Log) {
    const visualzar = this.$refs.visualizar as Visualizar;
    visualzar.open(log);
  }
}
